var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"delete-modal",attrs:{"visible":_vm.show,"title":_vm._f("translate")('Are you sure you want to delete?'),"ok-title":_vm._f("translate")('Confirm'),"cancel-title":_vm._f("translate")('Cancel')},on:{"hide":function () { return this$1.$emit('close'); },"ok":function () { return _vm.$emit('deleteUser'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }